export default __webpack_public_path__ + "static/images/fee961d1c6e2ca83e543c4775af4f4b0.png";